import axios from "axios";

export const userService = {
  logout,
  setAuthHeader,
};

function setAuthHeader() {
  // Return authorization header with jwt token
  const userToken = localStorage.getItem("prodms_token");

  if (userToken) axios.defaults.headers.common["Authorization"] = "Bearer " + userToken;
  else axios.defaults.headers.common["Authorization"] = null;
}

function logout() {
  // Remove user from localStorage
  localStorage.removeItem("prodms_token");
  setAuthHeader();
}
